module.exports = __webpack_public_path__ + "img/avatar-7.73b8d8e8.png";